class KeyFigures {
    constructor() {
        const numbers = document.querySelectorAll('.keyfigures__number');

        if (!numbers.length) return;

        numbers.forEach((number) => {
            KeyFigures.listen(number);
        });
    }

    static listen(number) {
        const time = 2000;
        const max = +number.innerText;
        let done = false;
        let i = 1;
        number.innerText = "0"; // eslint-disable-line

        const run = () => {
            if (done) return;
            const increment = () => {
                number.innerText = `${i}`; // eslint-disable-line
                i += 1;
            };

            const interval = setInterval(() => {
                increment();
                if (i > max) {
                    clearInterval(interval);
                }
            }, time / max);

            done = true;
        };

        window.addEventListener('scroll', () => {
            if (!done && number.getBoundingClientRect().top + 300 < window.innerHeight) {
                run();
            }
        });
    }
}

export default KeyFigures;
